// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6728bd8b","977":"240addac"}[chunkId] + ".chunk.js";
};